import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { config } from '@/config';
import { Notifications } from '@/components/dashboard/settings/notifications';
import { UpdatePasswordForm } from '@/components/dashboard/settings/update-password-form';

export default function SettingsPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Settings | Dashboard | {config.site.name}</title>
      </Helmet>
      <Stack spacing={3}>
        <div>
          <Typography variant="h4">Settings</Typography>
        </div>
        <Notifications />
        <UpdatePasswordForm />
      </Stack>
    </>
  );
}
